import clsx from 'clsx';

/**
 * Shared wrapper class for a comment card row across the annotated (asset) and
 * brief threads. Root cards are selectable (hover + selected elevation);
 * replies render flush. `isFlashing` drives the one-shot deep-link highlight.
 */
export function commentCardClassName({
  isRoot,
  isSelected,
  isFlashing = false,
  isFirstReply = false,
}: {
  isRoot: boolean;
  isSelected: boolean;
  isFlashing?: boolean;
  /** First reply in a thread — drops top padding so it sits flush under the separator. */
  isFirstReply?: boolean;
}): string {
  return clsx(
    isRoot && 'p-2 rounded-lg py-3 cursor-pointer border transition-[box-shadow,border-color]',
    isRoot &&
      (isSelected
        ? 'bg-card border-border shadow-md'
        : 'border-transparent hover:border-border hover:shadow-sm'),
    !isRoot && (isFirstReply ? 'pb-2' : 'py-2'),
    isFlashing && 'animate-comment-flash',
  );
}
